import { createApi } from '@/api'
export default {
  getScreenData: config => createApi(`/bigScreenData/get`, 'get', config), // 获取大屏数据
  saveScreenData: config => createApi(`/bigScreenData/save`, 'post', config), // 保存大屏数据
  getStaffList: config => createApi(`/bigScreenData/staff`, 'post', config) // 获取星级服务咨询列表
}



// WEBPACK FOOTER //
// ./src/views/screenManage/api/index.js